<section class="form-section">
  <div class="form-section__intro">
    <h2 class="form-section__heading">{{ heading }}</h2>
    @if (description) {
      <p class="form-section__description">{{ description }}</p>
    }
  </div>
  <div class="form-section__fields" [class.form-section__fields--single]="columns === 1">
    <ng-content></ng-content>
  </div>
</section>
